export default {
    report: 'Report',
    dailyReport: 'Daily Report',
    monthlyReport: 'Monthly Report',
    empMonthlyLogReport: 'Employee Monthly Log Report',
    branchOverviewReport: 'Branch Overview Report',
    allBranch: 'All Branch',
    attendanceReport: 'Attendance',
    visitorReport: 'Visitor activity'
}
